// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "footer .brand[data-v-3ddfd498]{width:225px}footer div.copyright[data-v-3ddfd498]{display:flex!important;padding:0}footer a.copyright[data-v-3ddfd498]{margin:0!important}footer p.copyright[data-v-3ddfd498]:first-of-type{display:none}@media(min-width:768px){footer p.copyright[data-v-3ddfd498]:first-of-type{display:block}}", ""]);
// Exports
module.exports = exports;
